import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppLoader from "../../../components/AppLoader";
import GlobalButton from "../../../components/CustomButton";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import { setUserRoutes } from "../../../lib/slices/userRoutes";
import { setUserData } from "../../../lib/slices/userSlice";
import { AdminRoutes } from "../../../routes";
import { loginAdmin } from "../../../services/authenticationApiFn";
import { encryptPassword, handleOpenSnackBar } from "../../../utils";
import { loginValidation } from "../../../utils/Validation";
import { useTranslation } from "react-i18next";

const LoginForm = () => {
  const { t } = useTranslation(["authentication", "common"]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [inputError, setInputError] = useState({});
  const [inputValues, setInputValues] = useState({
    email: "",
    password: "",
  });

  const handleLogin = async () => {
    try {
      const validate = loginValidation(inputValues, setInputError);
      if (validate) return handleOpenSnackBar("error", t("resolveTheIssues", { ns: "common" }));

      let payload = {
        email: inputValues.email,
        password: encryptPassword(inputValues.password),
      };

      setIsLoading(true);
      const response = await loginAdmin(payload);
      if (response.data.status === "success") {
        const userData = response?.data?.data.user;
        const token = response?.data?.data.token;
        const userWithToken = { ...userData, token };
        localStorage.setItem("user_data_admin", JSON.stringify(userWithToken));
        dispatch(setUserData(userWithToken));
        handleOpenSnackBar("success", response.data.message);

        if (userData?.role?.role === "admin") {
          localStorage.setItem("user-routes", JSON.stringify(AdminRoutes));
          dispatch(setUserRoutes(AdminRoutes));
          navigate("/");
        } else {
          let pages = userData?.role?.pages;
          let temmArr = [];

          pages?.map((itemmm) => {
            let ress = AdminRoutes?.find(
              (elemmm) => elemmm?.name == itemmm?.name
            );
            temmArr.push({
              ...itemmm,
              component: ress.component,
            });
          });
          dispatch(setUserRoutes(temmArr));
          localStorage.setItem("user-routes", JSON.stringify(temmArr));
          window.location.href = `${window.location.origin}${temmArr[0].path}`;
          // navigate(`${window.location.origin}/${temmArr[0].path}`);
        }
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      console.error(error)
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeValues = (event) => {
    const { name, value } = event.target;
    setInputError((prevError) => ({ ...prevError, [name]: "" }));
    setInputValues((pre) => ({ ...pre, [name]: value }));
  };

  return (
    <Box component={"form"} sx={{ mt: 3 }}>
      <AppLoader isVisible={isLoading} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Label
            labelText={t("emailAddress")}
            htmlFor={"email-address"}
            required
          />
          <TextInput
            id={"email-address"}
            placeholder={t("enterEmailAddress")}
            required={true}
            type={"email"}
            name="email"
            value={inputValues.email}
            onChange={handleChangeValues}
            inputError={Boolean(inputError.email)}
            helperText={t(inputError.email)}
          />
        </Grid>
        <Grid item xs={12}>
          <Label labelText={t("password")} htmlFor={"password"} required />
          <TextInput
            id={"password"}
            placeholder={t("enterPassword")}
            required
            type={showPass ? "text" : "password"}
            name="password"
            value={inputValues.password}
            onChange={handleChangeValues}
            inputError={Boolean(inputError.password)}
            helperText={t(inputError.password)}
            InputEndIcon={
              showPass ? (
                <Visibility
                  onClick={() => setShowPass(false)}
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <VisibilityOff
                  onClick={() => setShowPass(true)}
                  style={{ cursor: "pointer" }}
                />
              )
            }
          />
        </Grid>
      </Grid>
      {/* <Stack alignItems={"flex-end"} mt={1}>
        <Link
          to={"/forgot-password"}
          className="react-router-link"
          style={{
            color: palette.custom.slateGrey,
          }}
        >
          Forgot Password
        </Link>
      </Stack> */}
      <Box mt={3}>
        <GlobalButton
          variant={"contained"}
          btnText={"login"}
          handleClickBtn={handleLogin}
        />
      </Box>
    </Box>
  );
};

export default LoginForm;
